import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { tokenStorage } from '@/services/api/tokenStorage';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Handler for token expiration event
    const handleTokenExpired = () => {
      console.log('AuthProvider: Token expired event received, logging out...');
      tokenStorage.clearAuthData();
      navigate('/login');
    };

    // Add event listener
    window.addEventListener('auth:token-expired', handleTokenExpired);

    // Cleanup
    return () => {
      window.removeEventListener('auth:token-expired', handleTokenExpired);
    };
  }, [navigate]);

  return <>{children}</>;
};
